import { Box, Button, Container, Stack, Step, StepButton, Stepper } from '@mui/material'
import React, { useState } from 'react'
import AddDetails from './addDetails/AddDetails';
import AddImages from './addImages/AddImages';
import AddLocation from './addLocation/AddLocation';

const AddRoom = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([
        { label: 'location', completed: false },
        { label: 'Details', completed: false },
        { label: 'Images', completed: false },
    ])

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((activeStep) => activeStep + 1);
        } else {
            const stepIndex = findUnfinished();
            setActiveStep(stepIndex);
        }
    };
    const checkDisabled = () => {
        if (activeStep < steps.length - 1) return false;
        const index = findUnfinished();
        if (index !== -1) return false;
        return true;
    };
    const findUnfinished = () => {
        return steps.findIndex((step) => !step.completed);
    };



    return (
        <Container sx={{ my: 4 }}>
            <Stepper
                alternativeLabel
                nonLinear
                activeStep={activeStep}
                sx={{ mb: 3 }}
            >
                {steps.map((step, index) => (
                    <Step key={step.label} completed={step.completed}>
                        <StepButton onClick={() => setActiveStep(index)}>
                            {step.label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <Box>
                {{
                    0: <AddLocation />,
                    1: <AddDetails />,
                    2: <AddImages />,
                }  [activeStep]}
            </Box>
            <Stack
                direction='row'
                sx={{ pt: 2, pb: 7, justifyContent: 'space-around' }}
            >
                <Button
                    color='inherit'
                    disabled={!activeStep}
                    onClick={() => setActiveStep(activeStep => activeStep - 1) /* var => var -1  es una updater function */}
                >
                    Anterior
                </Button>
                <Button
                    color='inherit'
                    disabled={checkDisabled()}
                    onClick={handleNext}
                >
                    Siguiente
                </Button>
            </Stack>
        </Container>
    )
}

export default AddRoom